module.exports = __webpack_public_path__ + "static/media/resources-icon.ef9b6076.svg";